'use strict';

var skeleton = {};

exports.__exports = skeleton;
//# sourceMappingURL=skeleton.cjs.map
